export default {
  countryCode: 'CA',
  regionLinks: [
    {
      title: 'Vancouver',
    },
  ],
};
